import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";

interface Props {
  manga: Manga;
}

export default function MangaCard({ manga }: Props) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block rounded-xl overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative overflow-hidden aspect-[600/850]">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          title={`${manga.title}漫画 - 在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-background-950/70 text-background-50 backdrop-blur">
          {manga.category}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-accent-500 text-background-50">
          {manga.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-10 flex items-center justify-between">
          <span className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500"></i>
            {manga.rating}
          </span>
          <span className="text-background-50 text-xs">{manga.views} 人气</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-semibold text-foreground-950 text-sm truncate group-hover:text-primary-600 transition-colors">
          {manga.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-600 truncate">{manga.latestChapter}</p>
      </div>
    </Link>
  );
}